import KTCheckbox, { KTCheckboxType } from 'general/components/OtherKeenComponents/KTFormControls/KTCheckbox';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';

DragItem.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.object,
  index: PropTypes.number.isRequired,
  moveItem: PropTypes.func,
  checked: PropTypes.bool,
  onCheckChanged: PropTypes.func,
  onDragDone: PropTypes.func,
};

DragItem.defaultProps = {
  label: {},
  moveItem: null,
  checked: false,
  onCheckChanged: null,
  onDragDone: null,
};

/**
 *
 * @param {{
 * id: string,
 * label: object,
 * index: number,
 * moveItem: function,
 * checked: boolean,
 * onCheckChanged: function,
 * onDragDone: function,
 * }} props
 * @returns
 */
function DragItem(props) {
  // ---- params ----
  const { id, label, index, moveItem, checked, onCheckChanged, onDragDone } = props;
  const ref = useRef();
  const [{ handlerId }, drop] = useDrop({
    accept: 'CARD',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveItem(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: 'CARD',
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    end: (item, monitor) => {
      if (onDragDone) {
        onDragDone(item);
      }
    },
  });
  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  // console.log('check check: ', label?.props?.children, checked);
  return (
    <div
      ref={ref}
      key={id}
      className="py-2 px-2 border"
      style={{
        // border: '1px dashed gray',
        backgroundColor: 'white',
        cursor: 'move',
        opacity: opacity,
      }}
    >
      <KTCheckbox
        additionalClassName="checkbox-success"
        name={`checkbox_${id}`}
        label={
          <div className='ml-2'>
            {label?.props?.children}
          </div>
        }
        type={KTCheckboxType.default}
        checked={checked}
        onChange={(checked) => {
          if (onCheckChanged) onCheckChanged(id, checked);
        }}
      />
    </div>
  );
}

export default DragItem;
